import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  AfterViewInit,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {Router} from '@angular/router';
import { IonRouterOutlet, Platform} from '@ionic/angular';

@Component({
  selector: 'unr-main-header',
  templateUrl: 'main-header.component.html',
  styleUrls: [
    'main-header.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnrMainHeaderComponent implements OnInit, AfterViewInit {
  @Input() title = '';
  @Input() overrideBackButton = false;
  @Input() darkTheme = true;

  @Output() backButtonOverride: EventEmitter<any> = new EventEmitter<any>();

  
  canGoBack = false;
  isIos = false;

  constructor(private ionRouterOutlet: IonRouterOutlet,
              private router: Router,
              private platform: Platform) {
  }

  ngOnInit(): void {
    this.canGoBack = this.ionRouterOutlet.canGoBack() && this.title !== 'Roadtrips';
    console.log({canGoback : this.canGoBack});
    this.isIos = this.platform.is('ios');
  }

  ngAfterViewInit(): void {
    // this.backButton.onClick = ($event) => {
    //   if (this.backButtonOverride) {
    //     this.backButtonOverride.emit();
    //   } else {
    //     this.router.navigate(['roadtrips']);
    //   }
    // };
  }
}
